module.exports = __webpack_public_path__ + "static/vodafone-835c747c02a19356d80adc2762cefbe3.png";